var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tag-entry',{attrs:{"text":_vm.tag.name,"icon":_vm.tag.icon,"color":_vm.tag.color,"tag":_vm.tag,"showButtons":true}})}
var staticRenderFns = []

export { render, staticRenderFns }